import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskFooterService, TaskFooterType } from '@nimbus-assistant/services/task-footer.service';
import { FooterConnectedComponent } from './connected/footer-connected.component';
import { FooterIncomingComponent } from './incoming/footer-incoming.component';
import { FooterNarComponent } from './nar/footer-nar.component';
import { FooterOnHoldComponent } from './on-hold/footer-on-hold.component';
import { FooterParkedComponent } from './parked/footer-parked.component';
import { FooterTransferComponent } from './transfer/footer-transfer.component';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FooterConnectedComponent,
    FooterIncomingComponent,
    FooterNarComponent,
    FooterOnHoldComponent,
    FooterParkedComponent,
    FooterTransferComponent,
  ],
})
export class FooterComponent {
  public readonly TaskFooterType = TaskFooterType;
  public readonly footerState$ = this.taskFooterService.footerState$;

  public constructor(private readonly taskFooterService: TaskFooterService) {}
}
